import { getDevicePrefs } from "./devicePrefs";

// The wall monitor's power and backlight. The wall computer's loopback helper
// (kiosk/files/kinmantle-photos) turns the monitor to standby with wlopm and its
// backlight down over DDC/CI with ddcutil. Only the wall computer has the helper;
// on any other screen these do nothing.

const DISPLAY = "http://127.0.0.1:47200/v1/display";

export type DisplayMode = "on" | "dim" | "off";

/** What the helper can do with this monitor; null when there's no helper to ask. */
export interface DisplayInfo {
  /** The monitor can go to standby (and wake again). */
  off: boolean;
  /** Its backlight can be set (DDC/CI). */
  dim: boolean;
  mode: DisplayMode;
}

export function setDisplay(mode: DisplayMode, level = 10) {
  if (!getDevicePrefs().wallComputer) return;
  try {
    // A beacon is a plain POST with no body, so it goes without a preflight, and still
    // goes out while the page is being left.
    navigator.sendBeacon(mode === "dim" ? `${DISPLAY}?mode=dim&level=${Math.round(level)}` : `${DISPLAY}?mode=${mode}`);
  } catch {
    /* no helper: the dim clock is all there is */
  }
}

export async function getDisplayInfo(): Promise<DisplayInfo | null> {
  if (!getDevicePrefs().wallComputer) return null;
  try {
    // The helper looks for a DDC/CI monitor once at start, which can take a while.
    const res = await fetch(DISPLAY, { signal: AbortSignal.timeout(20_000) });
    return res.ok ? ((await res.json()) as DisplayInfo) : null;
  } catch {
    return null;
  }
}
